// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".class-nav--classNav--CHgXhIjV {\n  position: relative;\n  flex-shrink: 0;\n  height: 245px;\n  width: 240px;\n  background-color: #e2f4f8;\n  z-index: 1;\n}\n.class-nav--classNav--CHgXhIjV .class-nav--chooseClass--xy39Xsxy {\n  margin: 20px 0 15px 19px;\n}\n.class-nav--classNav--CHgXhIjV .class-nav--studentSort--43rbRPdC {\n  margin-left: 19px;\n}\n", ""]);
// Exports
exports.locals = {
	"classNav": "class-nav--classNav--CHgXhIjV",
	"chooseClass": "class-nav--chooseClass--xy39Xsxy",
	"studentSort": "class-nav--studentSort--43rbRPdC"
};
module.exports = exports;
